import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <section className="min-h-screen bg-background-dark pt-32 pb-20 px-4 md:px-10">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-surface-dark border border-border-dark text-primary text-xs font-bold mb-6 uppercase tracking-wider">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
            </svg>
            Security First
          </div>
          <h1 className="text-white text-4xl md:text-5xl font-bold mb-4 tracking-tight">
            Privacy Policy
          </h1>
          <p className="text-text-muted text-lg mb-6">Your data stays private. Always.</p>
          <div className="flex items-center justify-center gap-2 text-text-muted text-sm">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"/>
            </svg>
            <span>Last updated: December 31, 2025</span>
          </div>
        </div>

        {/* Key Statement Banner */}
        <div className="bg-surface-dark border border-border-dark rounded-2xl p-6 mb-12 flex items-start gap-4">
          <div className="flex-shrink-0 size-12 rounded-full bg-primary/20 flex items-center justify-center">
            <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
            </svg>
          </div>
          <div className="flex-1">
            <p className="text-white text-base leading-relaxed">
              "UPI Trackr analyzes only the transaction statements you choose to upload. We do not access bank accounts, initiate payments, or track activity."
            </p>
          </div>
        </div>

        {/* Feature Icons */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-16">
          <div className="flex flex-col items-center text-center p-4 bg-surface-dark border border-border-dark rounded-xl">
            <div className="size-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
              <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
              </svg>
            </div>
            <h3 className="text-white text-xs font-bold">PDF is Processed Locally</h3>
          </div>
          <div className="flex flex-col items-center text-center p-4 bg-surface-dark border border-border-dark rounded-xl">
            <div className="size-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
              <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/>
              </svg>
            </div>
            <h3 className="text-white text-xs font-bold">Encrypted Storage</h3>
          </div>
          <div className="flex flex-col items-center text-center p-4 bg-surface-dark border border-border-dark rounded-xl">
            <div className="size-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
              <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
              </svg>
            </div>
            <h3 className="text-white text-xs font-bold">Private Drive Backup</h3>
          </div>
          <div className="flex flex-col items-center text-center p-4 bg-surface-dark border border-border-dark rounded-xl">
            <div className="size-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
              <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"/>
              </svg>
            </div>
            <h3 className="text-white text-xs font-bold">No Ads, No Tracking</h3>
          </div>
          <div className="flex flex-col items-center text-center p-4 bg-surface-dark border border-border-dark rounded-xl">
            <div className="size-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
              <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
              </svg>
            </div>
            <h3 className="text-white text-xs font-bold">No Bank Access</h3>
          </div>
        </div>

        {/* Content */}
        <div className="space-y-8 text-text-light">
          {/* 1. Introduction */}
          <div>
            <h2 className="text-white text-2xl font-bold mb-4">1. Introduction</h2>
            <p className="mb-4 leading-relaxed">
              UPI Trackr ("we", "our", "us") is committed to protecting your privacy. This Privacy Policy explains how our application processes your data when you use it to analyze your financial statements.
            </p>
            <p className="leading-relaxed">
              The core function of UPI Trackr is to generate analytics from PDF statements you provide. We are not a bank, we do not facilitate payments, and we do not have access to your bank accounts directly.
            </p>
          </div>

          {/* 2. Information We Collect */}
          <div>
            <h2 className="text-white text-2xl font-bold mb-4">2. Information We Collect</h2>
            
            <h3 className="text-white text-xl font-semibold mb-3">2.1 PDF Statements</h3>
            <p className="mb-4 leading-relaxed">
              When you use the "Import Statement" feature, you select specific PDF files from your device storage. The app reads these files strictly to extract transaction details such as:
            </p>
            <ul className="list-disc list-inside space-y-2 mb-6 ml-4">
              <li>Date and time of transaction</li>
              <li>Merchant or Payee names</li>
              <li>Transaction amounts</li>
              <li>Reference numbers</li>
            </ul>

            <h3 className="text-white text-xl font-semibold mb-3">2.2 Information We DO NOT Collect</h3>
            <div className="bg-background-darker border border-border-dark rounded-lg p-6">
              <p className="text-white font-medium mb-3">We explicitly do not collect or access:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Bank account passwords or UPI PINS</li>
                <li>Real-time payment data</li>
                <li>SMS contents</li>
                <li>Contact lists or location data</li>
              </ul>
            </div>
          </div>

          {/* 3. How PDF Statements Are Processed */}
          <div>
            <h2 className="text-white text-2xl font-bold mb-4">3. How PDF Statements Are Processed</h2>
            <p className="mb-4 leading-relaxed">
              <strong className="text-white">Local Processing Only:</strong> The parsing and extraction of data from your uploaded PDF statements happens entirely on your device's processor.
            </p>
            <div className="bg-surface-dark border border-primary/30 rounded-lg p-6 mb-4">
              <p className="text-white font-medium mb-2">Important:</p>
              <p className="text-text-muted text-sm leading-relaxed">
                Your raw PDF files are never uploaded to our servers. The parsing engine runs locally within the app sandbox. Once the data is extracted into a structured format (e.g., spending categories), the original PDF is no longer accessed.
              </p>
            </div>
          </div>

          {/* 4. Data Storage & Encryption */}
          <div>
            <h2 className="text-white text-2xl font-bold mb-4">4. Data Storage & Encryption</h2>
            <p className="mb-4 leading-relaxed">
              After processing, the extracted transaction data is stored in a local database on your device. We use <strong className="text-white">SQLCipher</strong>, an industry-standard extension for SQLite that provides transparent 256-bit AES encryption of database files.
            </p>
            
            <h3 className="text-white text-xl font-semibold mb-3 mt-6">Cloud Backup (Optional)</h3>
            <p className="mb-4 leading-relaxed">You may choose to back up your data to Google Drive. If enabled:</p>
            <ul className="list-disc list-inside space-y-2 ml-4 mb-4">
              <li>Backups are encrypted before upload.</li>
              <li>Files are stored in the hidden "AppData" folder of your Google Drive.</li>
              <li>We cannot access these files; only the app signed in with your Google account can retrieve them.</li>
            </ul>
          </div>

          {/* 5. Contact Us */}
          <div>
            <h2 className="text-white text-2xl font-bold mb-4">5. Contact Us</h2>
            <p className="mb-4 leading-relaxed">
              If you have any questions about how we handle PDF processing or data security, please reach out:
            </p>
            <a 
              href="mailto:itsankar2005@gmail.com"
              className="inline-flex items-center gap-2 bg-primary text-background-dark px-6 py-3 rounded-full font-semibold hover:bg-opacity-90 transition-opacity"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
              </svg>
              itsankar2005@gmail.com
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
